import React, { Component } from 'react';
import { Button } from "@mui/material";

import Grid from '@mui/material/Grid2';

import { 
  TemplateBase
} from "@dndModels";

import API from "@utilities/smart_api";

import StringBox from "@components/input/strings/StringBox";
import SelectBox from "@components/input/selects/SelectBox";
import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";
import SelectStringBox from "@components/input/selects/SelectStringBox";
import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";
import LoadingBox from "@components/input/LoadingBox";
import ModalOrDrawer from "@components/display/ModalOrDrawer";

type Props = {
  obj: any;
  type: string;
  useTemplate: (template: TemplateBase) => void;
  useCreature: ((creature_id: string) => void) | null;
}

export interface State { 
  loading: boolean;
  type: string;
  categories: string[];
  selected_category: string;
  all_templates: TemplateBase[];
  templates: TemplateBase[];
  selected_template: TemplateBase | null; 
  processing: boolean;
  modal_open: boolean;
  new_template: TemplateBase | null;
  use_creature: boolean;
  creature_id: string;
}

const api = API.getInstance();

class TemplateBox extends Component<Props, State> {
  public static defaultProps = {
    useCreature: null
  };
  constructor(props: Props) {
    super(props);
    this.state = {
      type: "",
      categories: [],
      selected_category: "",
      all_templates: [],
      templates: [],
      selected_template: null,
      loading: true,
      processing: false,
      modal_open: false,
      new_template: null,
      use_creature: false,
      creature_id: ""
    };
  }

  componentDidMount() {
    this.load();
  }
  
  load() {
    this.setState({ loading: true }, () => {
      api.getObjects({data_type: "template"}).then(res => {
        const all_templates = res as TemplateBase[];
        const templates: TemplateBase[] = all_templates.filter(t => t.type === this.props.type);
        const categories: string[] = ["ALL", ...Array.from(new Set(templates.map(item => item.category)))];
        
        this.setState({
          all_templates,
          templates,
          loading: false,
          type: this.props.type,
          categories,
          selected_category: "ALL",
          selected_template: null
        });
      });
    });
  }

  render() {
    if (this.state.loading) {
      return (<LoadingBox />);
    } else {
      return (
        <Grid container spacing={0} direction="column">
          { this.props.type === "SummonStatBlock" && 
            <Grid>
              <ToggleButtonBox
                name="Use Creature as a Template"
                value={this.state.use_creature}
                onToggle={() => {
                  this.setState({ use_creature: !this.state.use_creature });
                }}
              />
            </Grid>
          }
          { this.state.use_creature ? 
            <Grid container spacing={0} direction="row">
              <Grid
                size={{
                  xs: 6
                }}>
                <SelectObjectBox 
                  name="Creature"
                  data_type="creature"
                  value={this.state.creature_id} 
                  onChange={(creature_id: string) => {
                    this.setState({ creature_id });
                  }}
                />
              </Grid>
              <Grid
                size={{
                  xs: 6
                }}>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={ this.state.creature_id === "" }
                  onClick={ () => { 
                    if (this.props.useCreature) {
                      this.props.useCreature(this.state.creature_id);
                    }
                  }}>
                  Use Creature as Template
                </Button>
              </Grid>
            </Grid>
          : 
            <Grid container spacing={0} direction="row">
              <Grid
                size={{
                  xs: 3
                }}>
                <SelectStringBox 
                  options={this.state.categories}
                  value={this.state.selected_category} 
                  name="Template Category"
                  onChange={(selected_category: string) => {
                    const templates = this.state.all_templates ? this.state.all_templates.filter(t => t.type === this.props.type && (selected_category === "ALL" || t.category === selected_category)) : [];
                    this.setState({ selected_category, templates });
                  }}
                />
              </Grid>
              <Grid
                size={{
                  xs: 3
                }}>
                <SelectBox 
                  options={this.state.templates}
                  value={ this.state.selected_template ? this.state.selected_template._id : "" } 
                  name="Template"
                  onChange={(id: string) => {
                    const objFinder = this.state.all_templates ? this.state.all_templates.filter(o => o._id === id) : [];
                    if (objFinder.length === 1) {
                      this.setState({ selected_template: objFinder[0] });
                    }
                  }}
                />
              </Grid>
              <Grid
                size={{
                  xs: 3
                }}>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={ this.state.selected_template === null }
                  onClick={ () => { 
                    if (this.state.selected_template) {
                      this.props.useTemplate(this.state.selected_template);
                    }
                  }}>
                  Use Template
                </Button>
              </Grid>
              <Grid
                size={{
                  xs: 3
                }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={ () => { 
                    // Create a template from the object
                    const new_template = new TemplateBase();
                    // debugger;
                    new_template.copyObj(this.props.obj);
                    new_template.type = this.props.type;
                    // Pass it to the modal.
                    this.setState({ new_template, modal_open: true });
                  }}>
                  Create Template
                </Button>
              </Grid>
              <ModalOrDrawer
                  aria-labelledby="delete-thing-modal"
                  aria-describedby="delete-thing-modal-description"
                  open={this.state.modal_open}
                  onClose={() => {this.setState({ modal_open: false })}}
                >
                <Grid container spacing={0} direction="column">
                  <Grid>
                    <StringBox
                      name="Template Name"
                      value={ this.state.new_template ? this.state.new_template.name : "" }
                      onBlur={(value: string) => {
                        if (this.state.new_template) {
                          const new_template = this.state.new_template;
                          new_template.name = value;
                          this.setState({ new_template });
                        }
                      }}
                    />
                  </Grid>
                  <Grid>
                    <StringBox
                      name="Template Category"
                      value={ this.state.new_template ? this.state.new_template.category : "" }
                      onBlur={(value: string) => {
                        if (this.state.new_template) {
                          const new_template = this.state.new_template;
                          new_template.category = value;
                          this.setState({ new_template });
                        }
                      }}
                    />
                  </Grid>
                  <Grid container spacing={0} direction="row">
                    <Grid
                      size={{
                        xs: 6
                      }}>
                      <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        disabled={ this.state.processing || !this.state.new_template || this.state.new_template.name === "" || this.state.new_template.category === "" }
                        onClick={() => {
                          this.setState({ processing: true }, () => {
                            if (this.state.new_template) {
                              api.createObject("template", this.state.new_template).then(res => {
                                if (this.state.new_template) {
                                  this.setState({ processing: false, modal_open: false }, () => {
                                    const templates = this.state.all_templates ? this.state.all_templates.filter(t => t.type === this.props.type && (this.state.selected_category === "ALL" || t.category === this.state.selected_category)) : [];
                                    this.setState({ templates });
                                  });
                                }
                              });
                            }
                          });
                        }}
                      >
                        Submit
                      </Button>
                    </Grid>
                    <Grid
                      size={{
                        xs: 6
                      }}>
                      <Button
                        fullWidth
                        variant="contained"
                        onClick={e => {this.setState({modal_open: false})}}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </ModalOrDrawer>
            </Grid>
          }
        </Grid>
      );
    }
  }
}

export default TemplateBox;
